import { render, staticRenderFns } from "./RidesStatistics.vue?vue&type=template&id=041cd8f1&scoped=true&lang=pug&"
import script from "./RidesStatistics.vue?vue&type=script&lang=js&"
export * from "./RidesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RidesStatistics.vue?vue&type=style&index=0&id=041cd8f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cd8f1",
  null
  
)

export default component.exports